<div>
  <div bsModal #uploadImageModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Add Image</h4>
        </div>
        <div class="modal-body">
          <input
            #inputfile
            type="file"
            (change)="setUploadFile($event.target.files)"
            multiple="true"
            accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .JPG, .PNG, .JPEG, .GIF, .BMP, .TIF, .TIFF|image/*"
            style="display: none" />

          <br />
          <button [disabled]="saving" *ngIf="!loading" class="btn btn-primary mr-2" (click)="inputfile.click()">
            Select files
          </button>
          <button [disabled]="!hasAttachments" *ngIf="!loading" class="btn btn-primary" (click)="openUploadModal()">
            Choose from attachment</button
          ><br />

          <div class="modal-body" *ngIf="loading">
            <ngx-loading
              [show]="loading"
              [config]="{
                animationType: ngxLoadingAnimationTypes.circle,
                primaryColour: primaryColour,
                secondaryColour: secondaryColour,
                backdropBackgroundColour: '#fff'
              }">
            </ngx-loading>
          </div>

          <div class="file-list" *ngIf="filesToUpload?.length && !loading">
            Selected files:
            <br />

            <ul style="list-style: none; padding-left: 0; word-break: break-all">
              <li *ngFor="let f of filesToUpload">
                <i class="fa fa-trash-o delete" (click)="removeImage(f)"></i>
                <span class="invalid-image" *ngIf="!f.isImage">not an image</span>
                <span class="invalid-image" *ngIf="f.tooLarge">file too large</span>
                {{ f.name }}
                <span *ngIf="saving && f.isImage">- {{ f.progress }}%</span>
              </li>
            </ul>
          </div>

          <button
            *ngIf="filesToUpload?.length && !loading"
            [disabled]="saving || !hasValidFiles"
            class="btn btn-primary"
            (click)="uploadFile()">
            Upload
          </button>

          <br />

          <div style="text-align: right">
            <button
              [disabled]="saving"
              *ngIf="!loading"
              type="button"
              class="btn btn-sm btn-sm aru btn-secondary"
              (click)="cancel()">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #uploadImageFromAttachmentsModal="bs-modal" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div style="width: 100%; height: 500px">
          <iframe #iframe [src]="boxUrl" style="border: 0; width: 100%; height: 100%"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
